import { lazyLoad } from 'utils/loadable';

export const DownloadPackagePurchasesReport = lazyLoad(() => import('./index'));
